import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
    Balance: {

        "& .BalancePrice": {
            color: '#0F42B6',
            textAlign: 'center',
            fontFamily: 'Lato',
            fontSize: '46px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: '100px',
        },
        "& .BalanceText": {
            color: '#8F8F8F',
            textAlign: 'center',
            fontFamily: 'Lato',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: 'normal',
        },
    },

    PaiChart: {
        position: 'relative'
    }
}));
